import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'

const saveUrlSelector = createSelector(
    entryDataSelector,
    (entryData): string | undefined => entryData.links?.find((link) => link.id === 'saveUrl')?.value,
)

export default saveUrlSelector
